import { useNavigate } from 'react-router-dom';
import { scrollToHash } from '../utils/scrollToHash';

// Единая кнопка "Назад" для внутренних страниц. В отличие от navigate(-1)
// (которая зависит от истории браузера и может увести хоть на google.com,
// если страница открыта напрямую по ссылке), ведёт на конкретный,
// осмысленный адрес — переданный явно каждой страницей.
export default function BackButton({ label, to = '/', hash, className = '' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
    if (hash) {
      setTimeout(() => scrollToHash(hash), 100);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`group glass-card inline-flex items-center gap-2.5 pl-2.5 pr-5 py-2.5 rounded-full text-sm font-display font-medium text-white/70 hover:text-cyan-300 hover:border-cyan-400/40 transition mb-10 ${className}`}
    >
      <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white/5 group-hover:bg-cyan-400/10 transition-all duration-300 group-hover:-translate-x-1">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      {label}
    </button>
  );
}
